exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sotsys211/work/src/ecard_new/backend/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main